// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"SR-z","inlineTitle":"TR-z","sponsoredAdsWrapper":"UR-z","marketplaceRecosWrapper":"VR-z"};